'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var PropTypes = require('prop-types');
var index = require('../core/index.js');
var _typeof = require('../utils/_typeof.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-", ": ", ";\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  ", ";\n  ", ";\n  ", "\n  ", ";\n\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Wrapper = styled__default['default'].div.attrs(function () {
  return {
    _component: 'space'
  };
})(_templateObject(), function (_ref) {
  var spaceDirection = _ref.spaceDirection;
  return spaceDirection === 'vertical' ? "flex-direction: column" : null;
}, function (_ref2) {
  var spaceDirection = _ref2.spaceDirection;
  return spaceDirection === 'vertical-reverse' ? "flex-direction: column-reverse" : null;
}, function (_ref3) {
  var spaceDirection = _ref3.spaceDirection;
  return spaceDirection === 'horizontal' ? "flex-direction: row; align-items: center;" : null;
}, function (_ref4) {
  var spaceDirection = _ref4.spaceDirection;
  return spaceDirection === 'horizontal-reverse' ? "flex-direction: row-reverse" : null;
}, function (props) {
  return props.hideScrollbar ? "::-webkit-scrollbar {\n    width: 0px;\n    height: 0px;\n    background: transparent;}" : null;
}, index.styleEngine);
var Item = styled__default['default'].div(_templateObject2(), function (props) {
  return props.spaceDirection === 'vertical' ? 'top' : 'left';
}, function (props) {
  return "".concat(props.gutter).concat(_typeof['default'](props.gutter) === 'number' ? 'px' : '');
}, index.styleEngine);
var Space = /*#__PURE__*/React.forwardRef(function (_ref5, ref) {
  var children = _ref5.children,
      gutter = _ref5.gutter,
      itemProps = _ref5.itemProps,
      direction = _ref5.direction,
      hideScrollbar = _ref5.hideScrollbar,
      _ref5$separator = _ref5.separator,
      separator = _ref5$separator === void 0 ? null : _ref5$separator,
      separatorProps = _ref5.separatorProps,
      restProps = _objectWithoutProperties(_ref5, ["children", "gutter", "itemProps", "direction", "hideScrollbar", "separator", "separatorProps"]);

  return /*#__PURE__*/React__default['default'].createElement(Wrapper, _extends({
    spaceDirection: direction
  }, restProps, {
    ref: ref
  }), React__default['default'].Children.toArray(children).filter(function (child) {
    return child !== null;
  }).map(function (child, inx, self) {
    var props = itemProps ? _typeof['default'](itemProps) === 'array' ? itemProps[inx] : itemProps : {};
    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(Item, _extends({
      gutter: inx === 0 ? 0 : _typeof['default'](gutter) === 'array' ? gutter[inx - 1] : gutter,
      spaceDirection: direction,
      key: inx
    }, props), child), separator && inx !== self.length - 1 ? /*#__PURE__*/React__default['default'].createElement(Item, _extends({
      spaceDirection: direction,
      gutter: gutter,
      key: inx
    }, separatorProps), separator) : null);
  }));
});
Space.defaultProps = {
  direction: 'horizontal',
  gutter: 8
};
Space.propTypes = {
  children: PropTypes__default['default'].node,
  direction: PropTypes__default['default'].oneOf(['horizontal', 'vertical']),
  gutter: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].array, PropTypes__default['default'].string]),
  itemProps: PropTypes__default['default'].array
};

exports.default = Space;
